import { createSelector } from 'reselect';

export const selectActiveMovementSpecialist = createSelector(
  (movementSpecialists, movementSpecialistId) =>
    movementSpecialists.get('data')
      ? movementSpecialists.getIn(['data', 'results']).find(ms => ms.get('id') === parseInt(movementSpecialistId, 10))
      : null,
  movementSpecialist => (movementSpecialist ? movementSpecialist : null)
);



// WEBPACK FOOTER //
// ./src/movement-specialists/selectors.js